import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const EnergyIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 19.26 11.854">
      <path
        d="M63.914,147.253a.526.526,0,0,1,.206-.419L74.7,138.69a.529.529,0,0,1,.852.419v4.225l6.764-1.49a.529.529,0,0,1,.415.952l-10.581,7.328a.529.529,0,0,1-.831-.435v-4.151l-6.711,2.216a.528.528,0,0,1-.7-.5Zm16.008-3.8-4.784,1.054a.53.53,0,0,1-.643-.517v-3.808l-7.265,5.592,4.454-1.471a.528.528,0,0,1,.7.5v3.873Z"
        transform="translate(-63.814 -138.472)"
        fill={props.color || theme.palette.primary.main}
        stroke={props.color || theme.palette.primary.main}
        strokeWidth="0.2"
      />
    </SvgIcon>
  );
};
